export type TranscriptExportOptions = {
  includeMarkers: boolean;
  includeIgnoredText: boolean;
  includeHighlights: boolean;
  includeSpeakerLabels: boolean;
};

export type TranscriptExporter = (options: TranscriptExportOptions) => string;

export const DEFAULT_TRANSCRIPT_EXPORT_OPTIONS: TranscriptExportOptions = {
  includeMarkers: true,
  includeIgnoredText: true,
  includeHighlights: true,
  includeSpeakerLabels: true,
};
